<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="urbanStudy.tostring" routeBack="UrbanStudyIndex"/>
        <show-actions
          :deleteItem=allowDelete
          :editItem=allowEdit
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <div class="row">

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text ">
                  {{ $t('urbanStudy.Name.of') }}
                </div>
                <div class="mt-2">
                  {{ getValue("name") }}
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6 mb-4">
                <div class="bold-text ">
                  {{ $t('urbanStudy.isViable') }}
                </div>
                <div class="mt-2">
                  <check-icon v-if="getValue('viability').value === 'VIABLE'" class="text-success"
                              size="26"></check-icon>
                  <x-icon v-if="getValue('viability').value === 'NONVIABLE'" class="viability-icon-nonviable"
                          size="24"></x-icon>
                  <question-mark-icon v-if="getValue('viability').value === 'TO_DEFINE'" size="24"></question-mark-icon>
                </div>
              </div>

              <div class="col-12 col-md-12 col-lg-12 mb-4">
                <div class="bold-text ">
                  {{ $t('urbanStudy.GeneralInfo') }}
                </div>
                <div class="mt-2" v-html="formatNewlines(getValue('generalInfo'))">
                </div>
              </div>

              <div class="col-12 col-md-12 col-lg-12 mb-4">
                <data-source-info-multi-tabs-show-field
                  :urbanStudyId="urbanStudyId">
                </data-source-info-multi-tabs-show-field>
              </div>

            </div>

            <div class="d-flex justify-content-end">
              <b-button v-if="urbanStudy.nbSimulations > 0" class="mr-3" variant="outline-primary"
                        @click="goToSimulationIndex">{{ $t('See') }} {{ $t('l.s') }} {{ $t('Simulations') }}
              </b-button>
              <b-button variant="primary" @click="goToSimulationCreate">{{ $t('Create') }} {{ $t('a.e') }}
                {{ $t('Simulation') }}
              </b-button>
            </div>

          </b-card>
        </div>

      </div>

    </b-container>

    <!-- Modal Delete -->
    <item-delete-modal
      :beginsWithVoyel="true"
      :isFeminine="true"
      :selectedItem="urbanStudy"
      controllerName="urbanStudy"
      itemSingularName="urbanStudy"
      itemSingularNameUpp="UrbanStudy"
      @didDeleteItem="didDeleteUrbanStudy()">
    </item-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import ShowActions from '../../components/b122/ShowActions'
import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'
import DataSourceInfoMultiTabsShowField from './DataSourceInfoMultiTabsShowField'

export default {

  name: 'UrbanStudyShow',

  components: {
    BackArrow,
    ShowActions,
    B122Table,
    ItemDeleteModal,
    DataSourceInfoMultiTabsShowField,
  },

  data() {
    return {
      allowDelete: true,
      allowResetPassword: true,
      allowEdit: true,
      urbanStudyId: this.$route.params.urbanStudyId,
      urbanStudy: {}
    }
  },

  computed: {
    getValue() {
      return property => (this.urbanStudy[property] || this.urbanStudy[property] === false) ? this.urbanStudy[property] : 'N/A'
    },

    getValueArray() {
      return property => (this.urbanStudy[property] && this.urbanStudy[property].length) ? this.urbanStudy[property].map(el => el.tostring).join(', ') : 'N/A'
    }

  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchUrbanStudy()
      this.fetchAuthorization()
    },


    formatNewlines(text) {
      if (!text) return '';
      return text.replace(/\n/g, '<br>');
    },

    fetchUrbanStudy() {
      api
        .get(`/urbanStudy/${this.urbanStudyId}`)
        .then(response => {
          this.urbanStudy = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: 'UrbanStudyIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    fetchAuthorization() {
      api
        .get(`/urbanStudy/getAuthorization/${this.urbanStudyId}`)
        .then(response => {
          this.allowDelete = response.data.allowDelete
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'UrbanStudyEdit',
        params: {
          urbanStudyId: this.urbanStudy.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteUrbanStudy() {
      this.$router.push({
        name: 'UrbanStudyIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(this.$i18n.t('UrbanStudy') + ' "' + this.urbanStudy.tostring + '" ' + this.$i18n.t('f.deleted'))
        })
      })
    },

    goToSimulationIndex() {
      this.$router.push({
        name: 'SimulationIndex',
        params: {
          urbanStudyId: this.urbanStudy.id
        }
      })
    },

    goToSimulationCreate() {
      this.$router.push({
        name: 'SimulationCreateEdit',
        params: {
          urbanStudyId: this.urbanStudy.id
        }
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/urbanStudy/UrbanStudyShow.vue